import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import Chart from 'react-google-charts';
import { Modal } from 'rsuite';

const VisualizarCliente = ({ modal, fecharModal, cliente }) => {
  const [loading, setLoading] = useState(true);
  const [dados, setDados] = useState([]);

  const listar = async () => {
    await api.get(`usuario/estatisticasCliente/${cliente.Id}`).then((res) => {
      let data = [];
      data.push(['Mes', 'Pedidos']);
      res.data.map((d) =>
        data.push([new Date(d.Ano, d.Mes - 1), parseInt(d.Quantidade)]),
      );
      setDados(data);
    });
    setLoading(false);
  };

  useEffect(() => {
    listar();
  }, [modal]);

  return (
    <Modal
      open={modal}
      onClose={fecharModal}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100%' - '0rem',
      }}
    >
      <Modal.Header>
        <Modal.Title>Dados do cliente</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mt-2">
          <p>
            Nome: <b>{cliente.Nome}</b>
          </p>
          <p>
            Telefone: <b>{cliente.Telefone}</b>
          </p>
          <p>
            E-mail: <b>{cliente.Email}</b>
          </p>
          <p>
            Pedidos: <b>{cliente.Quantidade}</b>
          </p>
        </div>
        {loading && (
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        {!loading && (
          <>
            <h5 style={{ textAlign: 'center', marginTop: 10 }}>
              Estetísticas de vendas
            </h5>
            <Chart
              chartLanguage="pt"
              width={'780px'}
              height={'400px'}
              chartType="LineChart"
              loader={<div>Carregando gráfico</div>}
              data={dados}
              options={{
                hAxis: {
                  title: 'Mês',
                },
                vAxis: {
                  title: 'Pedidos',
                },
              }}
            />
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default VisualizarCliente;
